import { ShoppingCartOutlined } from '@ant-design/icons';
import { List as ListModel } from '@omniafishing/core';
import { Button } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../hooks/use_cart';
import { useListAttributionUuid } from '../../hooks/use_list_attribution_uuid';
import { WebAnalyticsEventAreas } from '../../lib/web_analytics';
import { LINE_ATTRIBUTION } from '../../redux/cart';
import { RoutePaths } from '../../routes';
import { ProductCarousel } from '../carousel/product_carousel';
import { ProductCard } from '../product_card/product_card';
import styles from './list.less';

export interface ListProps {
  list: ListModel;
  style?: React.CSSProperties;
  noLinkTitle?: boolean;
  productClass?: string;
  desktopRowCount?: number;
}

export const List = (props: ListProps) => {
  const { list, style, noLinkTitle, productClass } = props;
  const { products, ambassador_code, shop_the_list_title, title, url_slug, description } = list;

  const { addToCart } = useCart();
  const list_uuid = useListAttributionUuid();

  const onCartAddAll = () => {
    const lineItemAttributes = [];
    if (ambassador_code) {
      lineItemAttributes.push({
        key: LINE_ATTRIBUTION.AMBASSADOR_CODE,
        value: ambassador_code,
      });
    }

    addToCart({
      productsToAdd: products.map((product) => ({
        product: {
          ...product,
          list_uuid,
        },
        quantity: 1,
      })),
      customAttributes: lineItemAttributes,
      position: 0,
    });
  };

  const listTitleText = shop_the_list_title || title;
  let listTitle: string | JSX.Element = listTitleText;
  if (!noLinkTitle && url_slug) {
    listTitle = <Link to={`${RoutePaths.LISTS}/${url_slug}`}>{listTitle}</Link>;
  }

  return (
    <div className={classNames(styles.list)} style={style}>
      <div className={styles.top}>
        <div className={styles.top_col1}>
          <p className={styles.type}>LIST</p>
          <h3 className={styles.heading}>
            <strong>{listTitle}</strong>
          </h3>
        </div>

        <div className={styles.top_col2}></div>
      </div>

      <div className={styles.bottom}>
        <div className={styles.bottom_col1}>
          {description && (
            <div className={styles.commentsWrapper}>
              <q className={styles.comments} dangerouslySetInnerHTML={{ __html: description }}></q>{' '}
            </div>
          )}
        </div>

        <div className={styles.bottom_col2}>
          <div className={styles.buttons}>
            <p className={styles.productCount}>
              {products.length} Product{products.length > 1 && 's'}
            </p>

            <Button
              icon={<ShoppingCartOutlined />}
              type="primary"
              className={classNames(styles.button, 'btn--shop')}
              onClick={onCartAddAll}
            >
              Add All to Cart
            </Button>
          </div>
        </div>
      </div>

      <section className={styles.productsWrapper}>
        <ProductCarousel
          products={products}
          arrows={true}
          list_id_title={listTitleText}
          list_uuid={list_uuid}
        >
          {products.map((product, i) => {
            return (
              <div key={product.sku} className={productClass}>
                <ProductCard
                  product={product}
                  area={WebAnalyticsEventAreas.MAIN_VIEW}
                  position={null}
                  list_uuid={list_uuid}
                />
              </div>
            );
          })}
        </ProductCarousel>
      </section>
    </div>
  );
};
